import React from "react";
import { Container, Row, Col } from "react-bootstrap";


const QueHacemos = () => {
    return (
        <section className="section bg-primary text-white vertical whatwedo" id="whatwedo">
            <Container>
                <Row>
                    <Col lg={3}>
                        <h1 className="heading1">¿Qué hacemos?</h1>
                    </Col>
                    <Col lg={6}>
                        <hr className="red-hr" />
                    </Col>
                </Row>
                <Row>
                    <Col className="content" lg={9}>
                        <p>
                            Nos dedicamos a integrar <strong>análisis prospectivo</strong> y estrategias avanzadas para apoyar
                            a nuestros clientes en la toma de decisiones informadas en entornos dinámicos.
                            A través de un <strong>enfoque personalizado</strong>, brindamos <strong>asesoría especializada</strong> con herramientas
                            prácticas que permiten a las organizaciones anticiparse a los desafíos futuros y
                            prosperar en un mundo cambiante.
                        </p>
                        <p>
                            Nuestro equipo colabora estrechamente con cada cliente para diseñar estrategias adaptadas
                            a sus necesidades, enfocándose en soluciones concretas que impulsen el desarrollo y el
                            crecimiento sostenido. Así, ayudamos a las organizaciones a fortalecer su competitividad y optimizar
                            sus procesos, asegurando que se mantengan un paso adelante en su evolución estratégica.
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default QueHacemos;